export const GET_TUTORIAL_VIDEOS = 'GET_TUTORIAL_VIDEOS';
export const GET_TUTORIAL_VIDEOS_SUCCESS = 'GET_TUTORIAL_VIDEOS_SUCCESS';

export const CREATE_TUTORIAL_VIDEO = 'CREATE_TUTORIAL_VIDEO';
export const EDIT_TUTORIAL_VIDEO = 'EDIT_TUTORIAL_VIDEO';
export const DELETE_TUTORIAL_VIDEO = 'DELETE_TUTORIAL_VIDEO';
